import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';

import MfproductEditFormImpl from 'components/mfproduct/MfproductEditFormImpl';
export default function ManageProductActionImpl(){

    return (
        <>
        <MfproductEditFormImpl/>
        </>
    )
}